import moment from 'moment'

export default {
    methods: {
        i18n(x) {
            if (x === null) {
                return x;
            } else if (this.$store && this.$store.state && this.$store.state.locale) {
                if (x[this.$store.state.locale]) {
                    return x[this.$store.state.locale];
                } else {
                    for (let t in x) {//Pour les enquêtes il n'y a pas forcément de traduction dans toutes les langues de l'app
                        if (x[t]) {
                            return x[t];
                        }
                    }
                }
            } else {
                // The store is not ready, not yet filled, ... fallback to FR
                return x['fr'];
            }
        },

        formatDateShortI18n(date) {
            switch (this.$store.state.locale) {
                case 'fr':
                case 'it':
                    return moment(date).format('DD/MM');

                case 'de':
                case 'lu':
                case 'ch':
                    return moment(date).format('DD.MM');

                default:
                    return moment(date).format('MM-DD');
            }
        },

        formatDateI18n(date) {
            switch (this.$store.state.locale) {
                case 'fr':
                case 'it':
                    return moment(date).format('DD/MM/YYYY');

                case 'de':
                case 'lu':
                case 'ch':
                    return moment(date).format('DD.MM.YYYY');

                default:
                    return moment(date).format('YYYY-MM-DD');
            }
        },

        formatDateHumanI18n(date) {
            switch (this.$store.state.locale) {
                case 'fr':
                case 'it':
                    return moment(date).format('dddd DD MMM YYYY');

                case 'de':
                case 'lu':
                case 'ch':
                    return moment(date).format('ddd DD MMMM YYYY');

                default:
                    return moment(date).format('ddd, MMM DD YYYY');
            }
        },

        formatShortDateHumanI18n(date) {
            switch (this.$store.state.locale) {
                case 'fr':
                case 'it':
                    return moment(date).format('DD MMM YYYY');

                case 'de':
                case 'lu':
                case 'ch':
                    return moment(date).format('DD MMMM YYYY');

                default:
                    return moment(date).format('MMM DD YYYY');
            }
        },

        formatMonthHumanI18n(date) {
            switch (this.$store.state.locale) {
                case 'fr':
                case 'it':
                    return moment(date).format('MMMM YYYY');

                case 'de':
                case 'lu':
                case 'ch':
                    return moment(date).format('MMMM YYYY');

                default:
                    return moment(date).format('MMMM YYYY');
            }
        },

        formatDateTimeHumanI18n(date) {
            switch (this.$store.state.locale) {
                case 'fr':
                case 'it':
                    return moment(date).format('dddd DD MMM YYYY, HH:mm');

                case 'de':
                case 'lu':
                case 'ch':
                    return moment(date).format('ddd DD MMMM YYYY, HH:mm');

                default:
                    return moment(date).format('ddd, MMM DD YYYY, hh:mma');
            }
        },

        formatDateTimeI18n(date) {
            switch (this.$store.state.locale) {
                case 'fr':
                case 'it':
                    return moment(date).format('DD/MM/YYYY HH:mm');

                case 'de':
                case 'lu':
                case 'ch':
                    return moment(date).format('DD.MM.YYYY HH:mm');

                default:
                    return moment(date).format('YYYY-MM-DD hh:mm');
            }
        },
        formatHour(date) {
            return moment(date).format('HH:mm');
        },
        formatDay(date) {
            return moment(date).format('DD');
        },

        joinListI18n(arr, field) {
            let items = [];

            for (let i = 0; i < arr.length; ++i) {
                items.push(arr[i][field][this.$store.state.locale]);
            }

            return items.join(', ');
        }
    },

    filters: {
        // usage: {{ file.size | prettyBytes }}
        prettyBytes(num) {
            // jacked from: https://github.com/sindresorhus/pretty-bytes
            num = parseInt(num);

            if (typeof num !== 'number' || isNaN(num)) {
                throw new TypeError('Expected a number');
            }

            var exponent;
            var unit;
            var neg = num < 0;
            var units = ['B', 'KiB', 'MB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

            if (neg) {
                num = -num;
            }

            if (num < 1) {
                return (neg ? '-' : '') + num + ' B';
            }

            exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
            num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
            unit = units[exponent];

            return (neg ? '-' : '') + num + ' ' + unit;
        }
    },

    computed: {
        _locale() {
            return this.$store.state.locale
        }
    }
}